
<div class="sc-main-wrap-d-and-m">
  <div v-if="isDesktopView" class="sc-main-wrap-d">
    <div v-if="!isStandalonePopupActive" class="sc-left-content-d">
      <div class="sc-arrow-btns-d">
        <cvt-section-up-down-actions 
          :vnode-id="vnodeId" 
          @moveSectionUp="moveSectionUp"
          @moveSectionDown="moveSectionDown"
        />
      </div>

      <div class="sc-section-action-btns-d">
        <cvt-section-setting-actions
          :vnode-id="vnodeId" 
          @copySection="copySection"
          @swapSection="swapSection"
          @deleteSection="deleteSection"
        />
      </div>
    </div>

    <div v-if="vnodeId" class="sc-mid-content-d">
      <cvt-section-drag-items 
        v-if="isGridBuilder" 
        :vnode-id="vnodeId" 
      />
    </div>

    <div v-if="!isStandalonePopupActive" class="sc-right-content-d">
      <cvt-section-visibility />
    </div>
  </div>

  <div v-if="isMobileView" class="sc-main-wrap-m">
    <div v-if="!isStandalonePopupActive" class="sc-left-content-m">
      <div class="sc-arrow-btns-m">
        <cvt-section-up-down-actions 
          :vnode-id="vnodeId" 
          @moveSectionUp="moveSectionUp"
          @moveSectionDown="moveSectionDown"
        />
      </div>

      <div class="sc-section-action-btns-m">
        <cvt-section-setting-actions
          :vnode-id="vnodeId" 
          @copySection="copySection"
          @swapSection="swapSection"
          @deleteSection="deleteSection"
        />
      </div>
    </div>

    <div v-if="vnodeId" class="sc-mid-content-m">
      <cvt-section-drag-items 
        v-if="isGridBuilder" 
        :vnode-id="vnodeId" 
      />
    </div>

    <div v-if="!isStandalonePopupActive" class="sc-right-content-m">
      <cvt-section-visibility />
    </div>
  </div>
</div>
